import { SET_LOADING_PERCENTAGE } from '../actions/ObjectLoaderActionTypes';

const initialState = {
  loadingPercentages: [],
};

const ObjectLoader = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING_PERCENTAGE:
      const { id, value } = action.payload;
      const foundIndex =
        state.loadingPercentages.length > 0 &&
        state.loadingPercentages?.findIndex((item) => item?.id === id);

      if (state.loadingPercentages.length > 0 && foundIndex !== -1) {
        return {
          ...state,
          loadingPercentages: state.loadingPercentages.map((item) =>
            item.id === id ? { id, value } : item
          ),
        };
      } else {
        return {
          ...state,
          loadingPercentages: [...state.loadingPercentages, { id, value }],
        };
      }

    default:
      return state;
  }
};

export default ObjectLoader;
